import { Chip } from "@mui/material";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import JoinProjectButton from "../JoinProjectButton/JoinProjectButton";
import { getColumns } from "../MyProjectsGrid/getMyProjectsGridColumns";
import TruncatedTooltip from "../../../../Common/components/TruncatedTooltip";

export const getOpenProjectColumns = (callForceRefresh: any): GridColDef[] => {
  const baseColumns = getColumns();

  const projectNameColumn = {
    field: "name",
    headerName: "Project name",
    disableColumnMenu: true,
    flex: 2,
    renderCell: (params: GridRenderCellParams<string>) => {
      const name = params.row.name;
      const isNew = params.row.isNew;

      return (
        <TruncatedTooltip title={name} placement="top-start">
          <span
            style={{
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              display: "block",
            }}
          >
            {name}
            {!!isNew && (
              <Chip sx={{ ml: "12px" }} size="small" color="info" label="New" />
            )}
          </span>
        </TruncatedTooltip>
      );
    },
  };

  const modifiedColumns = [...baseColumns];
  modifiedColumns[0] = projectNameColumn;

  return [
    ...modifiedColumns,
    {
      field: "actions",
      headerName: "",
      width: 200,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params: GridRenderCellParams<string>) => {
        const openRoles = params.row.openRoles.split(",");
        if (openRoles.length > 0) {
          openRoles.unshift("JOIN AS");
          return (
            <JoinProjectButton
              disabled={params.row.status === "Blocked"}
              projectId={params.row.id}
              roles={openRoles}
              isProvisioningFromApi={params.row.isProvisioning}
              callForceRefresh={callForceRefresh}
            />
          );
        }
      },
    },
  ];
};
